module.exports = __webpack_public_path__ + "img/3.113586c9.png";